export default __webpack_public_path__ + "static/zapier-logo-c71dfb10def644d2f7d5b9310ca94ceb.png";